import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/app.reducer";
import { GetMyDocuments, SearchDocuments, GetUnpublishedDocuments } from "src/app/features/home/resources/_store/resources.actions";
import { debounceTime } from "rxjs/operators";
import { NotificationsService } from "angular2-notifications";

@Component({
    selector: 'replace-document-dialog',
    styleUrls: ['./replace-document-dialog.component.scss'],
    templateUrl: './replace-document-dialog.component.html'
})

export class ReplaceDocumentDialogComponent implements OnInit {
    documentList;
    filteredDocuments;
    searchInput = new FormControl();
    myDocsPageNumber: number = 1;
    myDocsPages: number = 0;
    searchString: string;

    constructor(
        private store: Store<AppState>,
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notificationService: NotificationsService,
    ) {
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {
        const params = {
            page: this.myDocsPageNumber,
            limit: 20,
            filter: ""
        }
        this.store.dispatch(new GetUnpublishedDocuments(params));

        this.store.select(state => state.resources.unpublishedDocs).subscribe(response => {
            this.documentList = response['docList'];
            this.myDocsPageNumber = response['details'].page;
            this.myDocsPages = response['details'].pages;
        })

        /* listening to search input */
        this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
            if (searchString !== null) {
                params['filter'] = searchString.trim();
                this.searchString = searchString.trim();
                this.store.dispatch(new GetUnpublishedDocuments(params));
            }
        });
    }

    onClickingDocument(documentObj) {
        if (documentObj) {
            this.dialogRef.close(documentObj.document);
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onScroll(event) {
        const divViewHeight = event.target.offsetHeight; // viewport: ~500px
        const divScrollHeight = event.target.scrollHeight; // length of all table
        const scrollLocation = event.target.scrollTop; // how far user scrolled
        const buffer = 0;
        const limit = divScrollHeight - divViewHeight - buffer;

        //for my messages
        if (scrollLocation >= limit) {
            if (this.myDocsPageNumber < this.myDocsPages) {
                this.myDocsPageNumber++;
                const params = {
                    page: this.myDocsPageNumber,
                    limit: 20,
                    filter: this.searchString ? this.searchString : ""
                }
                this.store.dispatch(new GetUnpublishedDocuments(params));
            }

        }
    }
}